import React, { useState, useEffect, useRef } from "react";
import { Button, Chip, Stack, Typography } from "@mui/material";
import { FaUserPlus, FaInfoCircle } from "react-icons/fa";
import c1 from "./assets/01.png";
import c2 from "./assets/02.png";
import c3 from "./assets/03.png";
import c4 from "./assets/04.png";
import c5 from "./assets/05.png";
import c6 from "./assets/EnewsMobile.png";
import { FaLessThan } from "react-icons/fa6";
import { FaGreaterThan } from "react-icons/fa6";

const MobileSectionCarousel = ({ selectedIndex, onIndexChange }) => {
  const slides = [
    {
      id: 1,
      image: c1,
      title: "Subscribe to news on WhatsApp",
      description: "Get your daily news delivered to WhatsApp.",
      // description1: "Pick topics, pay once, get real-time updates!",
      paragraph: "#NewsOnWhatsApp",
      paragraph1: "#EnewsSubscription",
      paragraph2: "#ENewsOnWhatsApp",
    },
    {
      id: 2,
      image: c2,
      title: "WhatsApp-powered flight reservation",
      description: "From Chat to boarding gate in minutes!",
      // description1: "Book flights on WhatsApp while sipping.",
      paragraph: "#WhatsAppBookings",
      paragraph1: "#FlySmart",
    },
    {
      id: 3,
      image: c3,
      title: "Book your cab in just a few taps!",
      description: "Booking a cab just got smarter!",
      // description1: "Pick, payand go—right on WhatsApp.",
      paragraph: "#WhatsAppTaxi",
      paragraph1: "#NoAppNoWait",
    },
    {
      id: 4,
      image: c4,
      title: "Loan status? Just chat to know",
      description: "End-to-End loan journey on WhatsApp!",
      // description1: "Set amount, payand get funds instantly.",
      paragraph: "#LoanProcessOnChat",
      paragraph1: "#OnlineLoanApply",
    },
    {
      id: 5,
      image: c5,
      title: "Solve power issues on WhatsApp!",
      description: "Report electricity issues instantly!",
      // description1: "Report faults instantly—just a WhatsApp!",
      paragraph: "#ComplaintOnChat",
      paragraph1: "#WhatsAppSupport",
    },
    {
      id: 6,
      image: c1,
      title: "Switch plans, not apps",
      description: "Skip the app, recharge with WhatsApp!",
      // description1: "Pick a plan, payand recharge instantly!",
      paragraph: "#TelecomOnChat",
      paragraph1: "#PayviaWhatsApp",
    },
    {
      id: 7,
      image: c2,
      title: "WhatsApp your way into college",
      description: "Start your college journey with a 'Hi'!",
      // description1: "Apply for college on WhatsApp in few steps!",
      paragraph: "#EasyAdmission",
      paragraph1: "#StudentRegistration",
    },
    {
      id: 8,
      image: c3,
      title: "Get car insurance service in a chat",
      description: "Your digital insurance assistant is here!",
      // description1: "Stay protected—check details on WhatsApp.",
      paragraph: "#InsuranceOnWhatsApp",
      paragraph1: "#SecurePayments",
    },
    {
      id: 9,
      image: c4,
      title: "Sync Teams meetings on WhatsApp",
      description: "Instant meeting details right in your chat!",
      // description1: "Join meetings & get updates—no app switch!",
      paragraph: "#BroadcastOnWhatsApp",
      paragraph1: "#CRMIntegration",
    },
    {
      id: 10,
      image: c5,
      title: "Automate school tasks with ease",
      description: "Streamline school management on chat!",
      // description1: "Easy broadcasting for schools & teams.",
      paragraph: "#WhatsAppForSchools",
      paragraph1: "#SchoolBroadcast",
    },
    {
      id: 11,
      image: c1,
      title: "Food that finds you in chat",
      description: "Food delivery, now a chat away!",
      // description1: "Order menus, customize, all on WhatsApp.",
      paragraph: "#FoodOrderingOnChat",
      paragraph1: "#WhatsAppFoodDelivery",
    },
    {
      id: 12,
      image: c2,
      title: "Control home via WhatsApp",
      description: "Make your home smart with WhatsApp!",
      // description1: "Smart home control via WhatsApp!",
      paragraph: "#WhatsAppSmartHome",
      paragraph1: "#EnergyTracking",
    },
    {
      id: 13,
      image: c3,
      title: "Your health assistant is now on chat",
      description: "Get your test done with a single chat!",
      // description1: "Book tests, pick packages, get results easily.",
      paragraph: "#BookTestOnWhatsApp",
      paragraph1: "#InstantHealthcare",
    },
    {
      id: 14,
      image: c4,
      title: "PTM scheduling made effortless",
      description: "Stay updated with PTM on WhatsApp!",
      // description1: "Send reminders, gather feedback via chat.",
      paragraph: "#MeetingReminder",
      paragraph1: "#InstantSchoolUpdates",
    },
    {
      id: 15,
      image: c5,
      title: "Buy movie tickets instantly in chat",
      description: "Your cinema booking, now just a chat away!",
      // description1: "Get your movie ticket instantly on WhatsApp.",
      paragraph: "#BookMoviesOnChat",
      paragraph1: "#WebViewOnWhatsApp",
    },
  ];

  const touchRef = useRef({ startX: 0, endX: 0 });

  // Handle touch start
  const handleTouchStart = (e) => {
    touchRef.current.startX = e.touches[0].clientX;
  };

  // Handle touch move
  const handleTouchMove = (e) => {
    touchRef.current.endX = e.touches[0].clientX;
  };

  // Handle touch end to detect swipe direction
  const handleTouchEnd = () => {
    const deltaX = touchRef.current.endX - touchRef.current.startX;
    const swipeThreshold = 50; // Minimum swipe distance to trigger a slide change

    if (Math.abs(deltaX) > swipeThreshold) {
      if (deltaX > 0) {
        // Swipe right (previous slide)
        const newIndex =
          selectedIndex === 0 ? slides.length - 1 : selectedIndex - 1;
        onIndexChange(newIndex);
      } else if (deltaX < 0) {
        // Swipe left (next slide)
        const newIndex =
          selectedIndex === slides.length - 1 ? 0 : selectedIndex + 1;
        onIndexChange(newIndex);
      }
    }
  };

  return (
    <Stack
      sx={{
        width: { xs: "100%" },
        height: { xs: "68vh" },
        gap: 2,
      }}
      onTouchStart={handleTouchStart}
      onTouchMove={handleTouchMove}
      onTouchEnd={handleTouchEnd}
    >
      <Stack
        sx={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "center",
          height: { xs: "28%" },
          width: "100%",
          // border: "1px solid blue",
        }}
      >
        <Stack
          sx={{
            width: { xs: "96%" },
            // height: { xs: "26%" },
            height: { xs: "100%" },
            color: "#333",
            marginBottom: "0px",
            borderRadius: "8px",
            // border: "1px solid #ddd",
            backgroundColor: "rgb(233 240 244)",
            border: "1px solid rgb(233 240 244)",
            boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
            display: "flex",
            flexDirection: "row",
            justifyContent: "flex-start",
            alignItems: "center",
          }}
        >
          <Stack
            sx={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "flex-start",
              // border: "1px solid red",
              // marginBottom: "1px", // Reduced
                marginTop: "-8px",
            }}
          >
            <Stack
              sx={{
                display: "flex",
                flexDirection: "row",
                fontWeight: "bold",
                fontFamily: "'Roboto', sans-serif",
                color: "rgb(5 78 146)",
                marginBottom: "4px",
                // border: "1px solid red",
                // marginLeft: "6px",
                // marginRight: "6px",
                fontSize: {
                  xl: "20px",
                  lg: "20px",
                  md: "20px",
                  sm: "20px",
                  xs: "20px",
                },
              }}
            >
              <Stack
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <Stack
                  sx={{
                    width: { xl: "6px", lg: "6px", xs: "4px" },
                    height: {
                      xs: "20px",
                      sm: "44px",
                      md: "28px",
                      lg: "40px",
                      xl: "40px",
                    },
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    border: "1px solid rgb(5 78 146)",
                    backgroundColor: "rgb(5 78 146)",
                    marginRight: {
                      xs: "8px",
                    },
                    marginLeft: {
                      // xs: "8px",
                    },
                    borderTopRightRadius: "8px", // Adjust the value as needed
                    borderBottomRightRadius: "8px", // Adjust the value as needed
                  }}
                >
                  <h4 style={{ color: "rgb(5 78 146)" }}>{""}</h4>
                </Stack>
              </Stack>
              <span style={{ display: "inline-flex", alignItems: "center" }}>
                {slides[selectedIndex]?.title}
              </span>
            </Stack>

            <Typography
              variant="h6"
              sx={{
                color: "#333",
                marginRight: "8px",
                fontSize: {
                  xl: "20px",
                  lg: "20px",
                  md: "20px",
                  sm: "20px",
                  xs: "16px",
                },
                lineHeight: "22px",
                marginLeft: "12px",
                // marginTop: "4px",
                // border: "1px solid red",
              }}
            >
              {slides[selectedIndex]?.description}
            </Typography>
            <Typography
              variant="h6"
              sx={{
                color: "#333",
                marginBottom: "8px",
                marginRight: "8px",
                lineHeight: "20px",
                fontSize: {
                  xl: "20px",
                  lg: "20px",
                  md: "20px",
                  sm: "20px",
                  xs: "16px",
                },
                marginLeft: "8px",
                // border: "1px solid blue",
              }}
            >
              {slides[selectedIndex]?.description1}
            </Typography>
            <Stack
              variant="body1"
              sx={{
                color: "#666",
                marginBottom: "6px",
                fontSize: {
                  xl: "20px",
                  lg: "20px",
                  md: "20px",
                  sm: "20px",
                  xs: "8px",
                },
                paddingLeft: "8px",
                display: "flex",
                flexDirection: "row",
                gap: 1,
                marginLeft: "4px",
                marginTop: "6px",

              }}
            >
              <Chip
                label={slides[selectedIndex].paragraph}
                sx={{
                  borderRadius: "8px",
                  marginLeft: "0px",
                  color: "#666",
                  backgroundColor: "#f2f2f2",
                  boxShadow: "0 1px 3px rgba(0,0,0,0.2)",
                }}
              />
              <Chip
                label={slides[selectedIndex].paragraph1}
                sx={{
                  borderRadius: "8px",
                  color: "#666",
                  backgroundColor: "#f2f2f2",
                  boxShadow: "0 1px 3px rgba(0,0,0,0.2)",
                }}
              />
            </Stack>
            <Stack direction="row" spacing={2} sx={{ marginLeft: "8px" }}>
              <Button
                variant="contained"
                startIcon={<FaUserPlus />}
                sx={{
                  backgroundColor: "rgb(5 78 146)",
                  textTransform: "none",
                  borderRadius: "8px",
                  display: "none",
                }}
              >
                Sign up now
              </Button>
              <Button
                variant="outlined"
                startIcon={<FaInfoCircle />}
                sx={{
                  textTransform: "none",
                  borderRadius: "50px",
                  color: "rgb(5 78 146)",
                  borderColor: "rgb(5 78 146)",
                  display: "none",
                }}
              >
                Know more
              </Button>
            </Stack>
          </Stack>
        </Stack>
      </Stack>

      {/* Slides */}
      <Stack
        sx={{
          height: { xs: "68%" },
          width: { xs: "100%" },
          display: "flex",
          flexDirection: "row",
          justifyContent: "center",
          //  boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
        }}
      >
        <Stack
          direction="row"
          sx={{
            display: "flex",
            width: { xs: "96%" },
            // height: { xs: "66%" },
            height: { xs: "100%" },

            // boxShadow: "0 1px 3px rgba(0,0,0,0.1)",

            // border: "1px solid red",
          }}
        >
          <img
            src={slides[selectedIndex]?.image}
            alt={slides[selectedIndex]?.title}
            style={{
              width: "100%",
              height: "100%",
            }}
          />
        </Stack>
      </Stack>

      {/* Navigation Buttons - Removed */}
      {/* The buttons have been removed to rely solely on swipe gestures */}
    </Stack>
  );
};

export default MobileSectionCarousel;
